import CompanyPqeReasonInfo from './CompanyPqeReasonInfo'
export { CompanyPqeReasonInfo }
export default CompanyPqeReasonInfo
